import React from "react";

import FlightLandIcon from "@mui/icons-material/FlightLand";

function AirlinesIcon({ iconColor, iconSize = "small", ...other }) {
    return <FlightLandIcon color={iconColor} fontSize={iconSize} {...other} />;
}

export default AirlinesIcon;
